module.exports = __webpack_public_path__ + "assets/img/ic-exclamation-mark.42bed591.svg";